/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateLocationV1Dto = {
  /**
   * The name of the location.
   */
  name: string;
  /**
   * The description of the location.
   */
  propertyDescription?: string | null;
  /**
   * The total area of the location in square meters.
   */
  totalArea?: number | null;
  /**
   * The start date of the location.
   */
  startDate?: string | null;
  /**
   * The type of the location.
   */
  type?: CreateLocationV1Dto.type | null;
  /**
   * The address of the location.
   */
  addressId?: string | null;
};
export namespace CreateLocationV1Dto {
  /**
   * The type of the location.
   */
  export enum type {
    COMMERCIAL_CENTRE = 'CommercialCentre',
    OUTLET = 'Outlet',
    OFFICE_BUILDING = 'OfficeBuilding',
    STANDALONE = 'Standalone',
    RETAIL_CENTER = 'RetailCenter',
    OTHER = 'Other',
    COMMERCIAL_BUILDING = 'CommercialBuilding',
    MEDICAL_FACILITY = 'MedicalFacility',
  }
}
